module.exports = __webpack_public_path__ + "static/media/fly0117.eb0a6946.webp";